import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

declare const paypal: any;


export interface CheckoutRequest {

  resourceId: number;

  firstName: string;

  lastName: string;

  email: string;

  phone: string;

  consent: boolean;

}

export interface CheckoutCallbacks {

  paypalContainerId: string;

  onSuccess: (result: {
      orderId: string;
      downloadUrl: string;
  }) => void;

  onError: (message: string) => void;

}

@Injectable({
  providedIn: 'root'
})
export class PaypalService {

  private sdkLoaded = false;
  private sdkLoadingPromise!: Promise<void>;

  constructor() {}

  /**
   * Load PayPal SDK only once
   */
  loadSdk(): Promise<void> {

    if (this.sdkLoaded) {
      return Promise.resolve();
    }

    if (this.sdkLoadingPromise) {
      return this.sdkLoadingPromise;
    }

    this.sdkLoadingPromise = new Promise((resolve, reject) => {

      const existingScript = document.getElementById('paypal-sdk');

      if (existingScript) {
        this.sdkLoaded = true;
        resolve();
        return;
      }

      const script = document.createElement('script');

      script.id = 'paypal-sdk';

      script.src =
        `https://www.paypal.com/sdk/js?client-id=${environment.paypalClientId}` +
        `&currency=${environment.paypalCurrency}` +
        `&components=buttons,card-fields` +
        `&intent=capture`;

      script.onload = () => {
        this.sdkLoaded = true;
        resolve();
      };

      script.onerror = () => {
        reject('Unable to load PayPal SDK.');
      };

      document.body.appendChild(script);

    });

    return this.sdkLoadingPromise;
  }

  /**
   * Returns paypal object
   */
  getPaypal() {

    return paypal;

  }

}